import { Component, ViewChild, inject } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import {AutocompleteComponent, AutocompleteFilterCallback, IMenuOption} from "@tylertech/forge";
import {NavigationService, OmniSearchService} from "../../../services";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

export interface SearchOptionValue
{
    value: string;
    quickLink: boolean;
}

@Component({
    selector: "omni-search",
    templateUrl: "./omniSearch.tmpl.html",
    styleUrls: [
        "./omniSearch.component.scss"
    ],
    standalone: false
})
export class OmniSearchComponent
{
    private readonly $navigationService = inject(NavigationService);
    private readonly $omniSearchService = inject(OmniSearchService);

    @ViewChild("autocomplete") readonly autocomplete: AutocompleteComponent;

    filterText: string = "";

    autocompleteFilter: AutocompleteFilterCallback;

    constructor()
    {
        const activatedRoute = inject(ActivatedRoute);

        activatedRoute.queryParams
            .pipe(takeUntilDestroyed())
            .subscribe((params: Params) =>
            {
                if (params["QueryString"])
                    this.filterText = params["QueryString"];
            });

        this.autocompleteFilter = this.getItems.bind(this);
    }

    protected getItems(searchText: string): Promise<IMenuOption<SearchOptionValue>[]> 
{
        return this.$omniSearchService.GetAutoCompleteEntries(searchText).then((results) => 
{
            return results.map(x => (
                {
                    label: x.Label,
                    leadingIcon: x.Icon,
                    leadingIconType: "component",
                    value: {
                        value: x.Link,
                        quickLink: true,
                    }
                }
            ));
        });
    }

    onKeydown($event: KeyboardEvent): void
    {
        if ($event.key === "Enter")
        {
            this.autocomplete.value = this.autocomplete.filterText;
            this.executeSearch({ value: encodeURIComponent(this.autocomplete.value), quickLink: false });
        }
    }


    onSelectedItemChange(_$event: Event): void
    {
        if (this.autocomplete.value)
        {
            this.executeSearch(this.autocomplete.value);
        }
    }

    protected executeSearch(option: SearchOptionValue): void
    {
        const self = this;
        if (option.quickLink)
        {
            this.$navigationService.navigateToUrl(option.value);
        }
        else 
{
            this.$omniSearchService.AddRecentSearch(decodeURIComponent(option.value)).finally(() => 
{
                self.$navigationService.navigateToApp(
                    "globalSearch",
                    {
                        "QueryString": option.value
                    });
            });

        }
    }
}
